import { IObjectsControllable } from "./IObjectsControllable";
import { ILinkedPageObjectSpecifiable } from "./ILinkedPageObjectSpecifiable";

export interface ITranscribeBehaviorSpecifiable {
  transcribeBehavior: IObjectsControllable<ILinkedPageObjectSpecifiable>;
}

export function instanceOfITranscribeBehaviorSpecifiable(instance: any): instance is ITranscribeBehaviorSpecifiable {
  return instance
      && (instance.transcribeBehavior !== undefined);
}
